//@flow
import * as React from 'react'
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowInstructionLink from '../../components/common/ContainerRowInstructionLink'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import DocRenderIframe from './DocRenderIframe'

const DocLandingContainer=props=>{
    const { kratosec,location } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'EC18 Form Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'EC18 Form Data Extraction'} />
            <ContainerRowInstructionLink instructionLink={'http://'} docLink={query.docUrl} />
            <ContainerRowExpandPanel title={'PDF Content'} elementId={'pdfContent'} >
                <DocRenderIframe docUrl={query.docUrl} />
            </ContainerRowExpandPanel>
        </div>
    )   
}

const mapStateToProps = (state, ownProps) => {
    return {
        kratosec: state.kratosec
    }
}

export default connect(mapStateToProps)(DocLandingContainer)


// WEBPACK FOOTER //
// ./src/views/ProjectKratosEC/DocLandingContainer.js